









import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Team } from './store/models';
import TeamList from './components/TeamList.vue';

import { teamsModuleName } from './store/index';
import { Actions } from './store/actions';
import { Getters } from './store/getters';
const teamsModule = namespace(teamsModuleName);

import { leagueModuleName } from '@/modules/league/store/index';
import { Getters as LeagueGetters } from '@/modules/league/store/getters';
import { Actions as LeagueActions } from '@/modules/league/store/actions';
const leagueModule = namespace(leagueModuleName);

@Component({
  components: {
    TeamList,
  },
})
export default class Teams extends Vue {

  private isBusy: boolean = false;

  @leagueModule.Action(LeagueActions.FETCH_LEAGUE_SETTINGS) private fetchLeagueSettings!: () => void;
  @leagueModule.Getter(LeagueGetters.LOADED) private settingsLoaded!: number;
  @leagueModule.Getter(LeagueGetters.ACTIVE_SEASON_ID) private activeSeasonId!: number;

  @teamsModule.Getter(Getters.TEAMS) private teams!: string;
  @teamsModule.Getter(Getters.LOADED) private loaded!: boolean;
  @teamsModule.Action(Actions.FETCH_TEAMS) private fetchTeams!: (seasonId: number) => void;

  public async mounted() {
    if (!this.loaded) {
      this.isBusy = true;
      if (!this.settingsLoaded) {
        await this.fetchLeagueSettings();
      }
      await this.fetchTeams(this.activeSeasonId);
      this.isBusy = false;
    }
  }
}
